module.exports = __webpack_public_path__ + "img/hrob02.6624caea.png";